<template>
    <div>
        <h2>This is Catering Header Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'CateringHeader'
  }
</script>
  
<style scoped>
 
</style>